<template>
  <div style="width:100%;background:#fff;">
    <div style="text-ailgn:center;">
      <div class="headerMain">
        <img src="@/assets/logo.png" class="img" />
        <div>
          <div>
            <div style="text-align:right;font-size:13px;margin-bottom:20px;cursor: pointer;">
              <span @click="setHome">设为首页</span>
              <el-divider direction="vertical"></el-divider>
              <span @click="addFavorite">加入收藏</span>
              <el-divider direction="vertical"></el-divider>
              <span @click="toArtical">联系我们</span>
            </div>
            <el-input
              placeholder="请输入内容"
              style="width:400px"
              v-model="value"
              @keyup.enter.native="toResult"
              class="input-with-select"
            >
              <el-button slot="append" icon="el-icon-search" @click="toResult"></el-button>
            </el-input>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      value: "",
    };
  },
  methods: {

    toResult(){
      var routeData =  this.$router.resolve({
        name: "Search",
        query: {
          key: this.value,
        }
      });
      window.open(routeData.href, '_blank');
    },
    toArtical(){
      var path = '/Content'
      var routeData =  this.$router.resolve({
        path: path,
        query: {
          type:'首页',
          typeId:'ff8080817e7ba2ae017e7fca886b0023',
          articleId: '2c9151b47f71aae7017f7cd8aedd0002'
        }
      });
      window.open(routeData.href, '_blank');
    },
    addFavorite() {
      var url = window.location;
      var title = document.title;
      var ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf("360se") > -1) {
        alert("由于360浏览器功能限制，请按 Ctrl+D 手动收藏！");
      } else if (ua.indexOf("msie 8") > -1) {
        window.external.AddToFavoritesBar(url, title); //IE8
      } else if (document.all) {
        //IE类浏览器
        try {
          window.external.addFavorite(url, title);
        } catch (e) {
          alert("您的浏览器不支持,请按 Ctrl+D 手动收藏!");
        }
      } else if (window.sidebar) {
        //firfox等浏览器；
        window.sidebar.addPanel(title, url, "");
      } else {
        alert("您的浏览器不支持,请按 Ctrl+D 手动收藏!");
      }
    },
    setHome(obj) {
      var url = window.location.href;
      try {
        obj.style.behavior = "url(#default#homepage)";
        obj.setHomePage(url);
      } catch (e) {
        if (window.netscape) {
          try {
            netscape.security.PrivilegeManager.enablePrivilege(
              "UniversalXPConnect"
            );
          } catch (e) {
            alert(
              "抱歉，此操作被浏览器拒绝！\n\n请在浏览器地址栏输入“about:config”并回车然后将[signed.applets.codebase_principal_support]设置为'true'"
            );
          }
        } else {
          alert(
            "抱歉，您所使用的浏览器无法完成此操作。\n\n您需要手动将【" +
              url +
              "】设置为首页。"
          );
        }
      }
    },
  },
};
</script>

<style>
.headerMain {
  width: 1200px;
  height: 120px;
  background: #fff;
  padding: 30px 0 0;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.headerMain .img {
  width: 542px;
  height: 85px;
}
.headerMain .el-input-group__append {
  background: #034f92;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  color: #fff;
}
.headerMain .el-input__inner {
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
}
</style>
